import { call, put, takeEvery } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { multipleDomainScanApi } from '../api/multipleDomainApi';
import {
  MULTIPLE_DOMAIN_SCAN_REQUEST,
  MULTIPLE_DOMAIN_SCAN_SUCCESS,
  MULTIPLE_DOMAIN_SCAN_FAILURE
} from '../constants/multipleDomainConstants';

function* multipleDomainScanSaga(action) {
  try {
    const response = yield call(multipleDomainScanApi, action.payload);
    yield put({ type: MULTIPLE_DOMAIN_SCAN_SUCCESS, payload: response });
    // toast.success(response.message || 'The cybersecurity report is being prepared and will be sent to you within 24 hours.');
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    yield put({ 
      type: MULTIPLE_DOMAIN_SCAN_FAILURE, 
      payload: errorMessage 
    });
    toast.error(errorMessage || 'Failed to submit scan request');
  }
}

function* watchMultipleDomainScan() {
  yield takeEvery(MULTIPLE_DOMAIN_SCAN_REQUEST, multipleDomainScanSaga);
}

export default watchMultipleDomainScan;